import { createContext } from "react";
import { Client, Model, Offer, User } from "../interfaces";

type MainCtx = {
  pageHeight: number;
  setPageHeight: React.Dispatch<React.SetStateAction<number>>;
  refresh: boolean;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  token: string | null;
  setToken: React.Dispatch<React.SetStateAction<string | null>>;
  modelSelector: {
    onModelSelection: boolean;
    setOnModelSelection: React.Dispatch<React.SetStateAction<boolean>>;
    tempModelList: Model[];
    setTempModelList: React.Dispatch<React.SetStateAction<Model[] | []>>;
    modelList: Model[];
    setModelList: React.Dispatch<React.SetStateAction<Model[] | []>>;
  };
  user: User | null;
  userTreated: User | null;
  offer: Offer | null;
  client: Client | null;
  model: Model | null;
  setUser: React.Dispatch<React.SetStateAction<User | null>>;
  setUserTreated: React.Dispatch<React.SetStateAction<User | null>>;
  setOffer: React.Dispatch<React.SetStateAction<Offer | null>>;
  setClient: React.Dispatch<React.SetStateAction<Client | null>>;
  setModel: React.Dispatch<React.SetStateAction<Model | null>>;
};

const defaultContext = {
  pageHeight: 0,
  setPageHeight: () => {},
  refresh: false,
  setRefresh: () => {},
  token: null,
  setToken: () => {},
  modelSelector: {
    onModelSelection: false,
    setOnModelSelection: () => {},
    tempModelList: [],
    setTempModelList: () => {},
    modelList: [],
    setModelList: () => {},
  },
  user: null,
  userTreated: null,
  offer: null,
  client: null,
  model: null,
  setSelectorList: () => {},
  setUser: () => {},
  setUserTreated: () => {},
  setOffer: () => {},
  setClient: () => {},
  setModel: () => {},
};

const MainContext = createContext<MainCtx>(defaultContext);

export default MainContext;
